import LandingHeader from "../../components/landing/LandingHeader";
import Footer from "../../components/landing/Footer";
import ProcessSection from "../../components/landing/process/ProcessSection";
import BentoSection from "../../components/landing/bento/BentoSection";
import StatsSection from "../../components/landing/StatsSection";
import PowerUpFeatures from "../../components/landing/PowerUpSection";
import ExploreMoreSection from "../../components/landing/ExploreMoreSection";
import ContactWidget from "../../components/landing/ContactWidget";
import InterestedSection from "../../components/landing/InterestedSection";
import { useEffect } from "react";
import { Grid, Stack } from "@mui/material";
// import MainValueSection from "../../components/landing/MainValueSection";

const Landing = () => {
  useEffect(() => {
    document.title = "Majura - Move Freight, Not Paperwork";
  }, []);

  return (
    <div style={{ width: "100vw", height: "100%" }}>
      <Grid container spacing={0} style={{ width: "100%" }}>
        <Grid size={{ xs: 12 }}>
          <LandingHeader />

          <main>
            <Stack
              direction={"column"}
              spacing={{ xs: '100px', md: "150px" }}
              style={{ width: "100%" }}
            >
              <div style={{ width: "100%" }}>
                <ProcessSection />
              </div>

              <BentoSection />

              <section id={'stat-section'} style={{ width: "100%", display: "flex", gap: "50px", flexDirection: "column" }}>
                <StatsSection />

                <PowerUpFeatures />
              </section>

              <div>
                <ExploreMoreSection />
                <InterestedSection />
              </div>
            </Stack>
          </main>

          <footer>
            <Footer />
          </footer>

          <ContactWidget />
        </Grid>
      </Grid>
    </div>
  );
};

export default Landing;
